var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn btn--default",class:{'btn--disabled': _vm.disabled},attrs:{"role":"button"}},[_c('span',{staticClass:"btn__label",attrs:{"id":"button-chatbot"}},[_vm._t("default",function(){return [_vm._v("\n\t"+_vm._s(_vm.label)+"\n\t")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }